import { Injectable, inject } from '@angular/core'; // Sorted
import { Actions, createEffect, ofType } from '@ngrx/effects'; // Sorted
import { catchError, map, of, switchMap } from 'rxjs'; // Sorted
import { CustomerDataService } from '../services/customer-data.service'; // Added service import
import * as CustomerSettingsActions from './customer-settings.actions';

@Injectable()
export class CustomerSettingsEffects {
  private actions$ = inject(Actions);

  private customerDataService = inject(CustomerDataService); // Injected service + Added blank line

  lookupCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerSettingsActions.lookupCustomer), // Listen for our action
      switchMap(
        (
          { domain } // Use switchMap to handle cancellation & get domain
        ) =>
          this.customerDataService.getCustomerData(domain).pipe(
            // Call the service
            map(
              (
                customerMetadata // Map success response to success action
              ) =>
                CustomerSettingsActions.lookupCustomerSuccess({
                  customerMetadata,
                })
            ),
            catchError((error: unknown) => {
              // Type error as unknown
              // Extract message or provide a default
              const errorMessage =
                error instanceof Error
                  ? error.message
                  : 'An unknown error occurred';
              return of(
                CustomerSettingsActions.lookupCustomerFailure({
                  error: errorMessage,
                })
              ); // Pass string message
            })
          )
      )
    )
  );
}
